export const ENV_DATADOG_RUM_APP_ENV =
  import.meta.env.VITE_DATADOG_RUM_APP_ENV || 'development'
export const ENV_DATADOG_RUM_APP_ID =
  import.meta.env.VITE_DATADOG_RUM_APP_ID ?? ''
export const ENV_DATADOG_RUM_APP_TOKEN =
  import.meta.env.VITE_DATADOG_RUM_APP_TOKEN ?? ''
export const ENV_DATADOG_RUM_APP_NAME =
  import.meta.env.VITE_DATADOG_RUM_APP_NAME ?? ''
export const ENV_ENABLE_DD_RUM = import.meta.env.VITE_ENABLE_DD_RUM || 'false'
export const ENV_ENABLE_DD_RUM_DEBUG =
  import.meta.env.VITE_ENABLE_DD_RUM_DEBUG || 'false'
export const ENV_APP_VERSION = import.meta.env.VITE_APP_VERSION || '0.0.0'
